import { AUTH_SESSION_EXCHANGE_ENDPOINT } from './endpoints';

type SessionExchangePayload = {
  accessToken?: string;
  idToken?: string;
};

export const exchangeAuthTokenForSession = async (
  payload: SessionExchangePayload,
) => {
  return fetch(AUTH_SESSION_EXCHANGE_ENDPOINT, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
    body: JSON.stringify(payload),
  });
};
